/**
 * EndNode.tsx
 * Endノードのビューコンポーネント
 * フローの終了点を視覚的に表現する赤色の円形ノード
 */
import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';

/**
 * Endノードの表示コンポーネント
 * - 左側にのみ接続ハンドル（target）を持つ
 * - memoで不要な再レンダリングを防止
 */
export const EndNodeView = memo(function EndNodeView() {
  const displayLanguage = useFlowDisplayLanguage();

  return (
    <div className="flow-node flow-node--terminal rounded-full border-2 border-red-500 bg-red-50 shadow-sm">
      <div className="flow-node__title text-center font-semibold text-red-700">
        {getNodeDisplayLabel('end', displayLanguage)}
      </div>
      {/* 入力ハンドル：他のノードからここへ接続される */}
      <Handle type="target" position={Position.Left} className="!bg-red-500" />
    </div>
  );
});

